import { parseISO } from 'date-fns';

/**
 * Toeslag op een feestdag (CAO art 41: +50% op het basisuurloon). Stapelt met de gewone
 * toeslag: avond +10% → +60%, nacht +20% → +70%, weekend +35% → +85%.
 */
export function feestToeslag(date: string): { kort: string; lang: string } {
  const dag = parseISO(date).getDay();
  if (dag === 0 || dag === 6) return { kort: '+85%', lang: '+85% toeslag (feestdag 50% + weekend 35%)' };
  return { kort: '+50%', lang: '+50% toeslag, avond +60%, nacht +70%' };
}
